/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_Password_TitleInputs */

const en_auth_forgot_password_title = /** @type {(inputs: Auth_Forgot_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot Password`)
};

const es_auth_forgot_password_title = /** @type {(inputs: Auth_Forgot_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer contrasena`)
};

/**
* | output |
* | --- |
* | "Forgot Password" |
*
* @param {Auth_Forgot_Password_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_password_title = /** @type {((inputs?: Auth_Forgot_Password_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_Password_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_password_title(inputs)
	return es_auth_forgot_password_title(inputs)
});